"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filesize = void 0;
const helpers_1 = require("../helpers");
const DEFAULTS = {
    si: false
};
function filesize(opts) {
    const si = opts.si;
    const fn = function filesizeFormatter(row, cell, value, columnDef, data) {
        return value == null ? '' : (0, helpers_1.humanFileSize)(value, si);
    };
    fn.filterFormattedData = true;
    return fn;
}
exports.filesize = filesize;
//# sourceMappingURL=filesize.js.map